module.exports = "/assets/data/d5878e1a9b1f2eea4837bb0398680c0e-LE7.data.json";